import { DashboardActionTypes } from "./constants";

const INIT_STATE = {
    activeOffices: [],
    registeredVisits: [],
    visitsByCountry: [],
    visitsByRegion: [],
    info: [],
    loading: false,
    error: false,
};

type DashboardAction = { type: string, payload: {} | string };
type State = { activeOffices?: [] | null, registeredVisits?: [] | null, visitsByCountry?: [] | null, visitsByRegion?: [] | null, info?: [] | null, loading?: boolean, error?: boolean };

const Dashboard = (state: State = INIT_STATE, action: DashboardAction): any => {
    // console.log(action);
    switch (action.type) {
        case DashboardActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DashboardActionTypes.GET_ACTIVE_OFFICES: {
                    return {
                        ...state,
                        activeOffices: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_REGISTERED_VISITS: {
                    return {
                        ...state,
                        registeredVisits: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_VISITS_BY_COUNTRY: {
                    return {
                        ...state,
                        visitsByCountry: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_VISITS_BY_REGION: {
                    return {
                        ...state,
                        visitsByRegion: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_INFO_SENDED: {
                    return {
                        ...state,
                        info: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }

                default:
                    return { ...state };
            }
        case DashboardActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DashboardActionTypes.GET_ACTIVE_OFFICES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_REGISTERED_VISITS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_VISITS_BY_COUNTRY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_VISITS_BY_REGION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_INFO_SENDED: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }
        case DashboardActionTypes.RESET: {
            return { ...INIT_STATE };
        }
        case DashboardActionTypes.GET_ACTIVE_OFFICES: {
            return {...state, loading: true, error: false};
        }
        case DashboardActionTypes.GET_REGISTERED_VISITS: {
            return {...state, loading: true, error: false};
        }
        case DashboardActionTypes.GET_VISITS_BY_COUNTRY: {
            return {...state, loading: true, error: false};
        }
        case DashboardActionTypes.GET_VISITS_BY_REGION: {
            return {...state, loading: true, error: false};
        }
        case DashboardActionTypes.GET_INFO_SENDED: {
            return {...state, loading: true, error: false};
        }
        default:
            return { ...state };
    }
};

export default Dashboard;


